import { createAction, props } from '@ngrx/store';
import { AgreementsApi } from '../../model/agreements.model';
import AppError from '../../model/app-error';

export enum AgreementsActions {
  Reset = '[Agreements] Reset',
  FetchStart = '[Agreements] Fetch Start',
  FetchSuccess = '[Agreements] Fetch Success',
  FetchError = '[Agreements] Fetch Error',
}

const reset = createAction(AgreementsActions.Reset);
const fetchStart = createAction(AgreementsActions.FetchStart);
const fetchSuccess = createAction(AgreementsActions.FetchSuccess, props<{ data: AgreementsApi }>());
const fetchError = createAction(AgreementsActions.FetchError, props<{ error: AppError | null }>());

const agreementsActions = {
  reset,
  fetchStart,
  fetchSuccess,
  fetchError,
};

export default agreementsActions;
